import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

// Mirrors AdminRoute. Created in M2 for the agent-facing dashboard that arrives in M3;
// no route consumes it yet (harmless until then).
const AgentRoute = ({ children }) => {
  const userType = useSelector((state) => state.accountReducer.userInfo?.userType);

  if (userType !== "Agent") {
    return <Navigate to="/" />;
  }

  return children;
};

export default AgentRoute;
